<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-ibase-cru-modal-content [showDefaultFormFooter]="true" [contentClasses]="['floatingLabelContainer']">
        <div class="hcol-flex">
            <div class="hcol-50 floatingLabelContainer">
                <p-floatlabel variant="on">
                    <input id="name" type="text" pInputText formControlName="name" />
                    <label for="name">Name</label>
                </p-floatlabel>

                <p-floatlabel variant="on">
                    <textarea
                        id="description"
                        rows="5"
                        cols="30"
                        pInputTextarea
                        formControlName="description"
                    ></textarea>
                    <label for="description">Description</label>
                </p-floatlabel>
            </div>

            <div class="hcol-50 floatingLabelContainer">
                <p-floatlabel variant="on">
                    <input id="api_endpoint" pInputText formControlName="api_endpoint" />
                    <label for="api_endpoint">API Endpoint</label>
                </p-floatlabel>

                <p-floatlabel variant="on">
                    <input id="region" pInputText formControlName="region" />
                    <label for="region">Region</label>
                </p-floatlabel>

                <p-floatlabel variant="on">
                    <input id="bucket" pInputText formControlName="bucket" />
                    <label for="bucket">Bucket</label>
                </p-floatlabel>

                <p-floatlabel variant="on">
                    <input id="access_key" pInputText formControlName="access_key" />
                    <label for="access_key">
                        @if (!isCreationMode) {
                            Update
                        }
                        Access Key</label
                    >
                </p-floatlabel>

                <p-floatlabel variant="on">
                    <p-password
                        [toggleMask]="true"
                        formControlName="access_secret"
                        id="access_secret"
                        [feedback]="false"
                    ></p-password>
                    <label for="access_secret">
                        @if (!isCreationMode) {
                            Update
                        }
                        Access Secret</label
                    >
                </p-floatlabel>

                <p-floatlabel variant="on">
                    <p-select
                        id="verify_ssl"
                        formControlName="verify_ssl"
                        [autoDisplayFirst]="false"
                        [options]="_booleanOptions"
                        optionLabel="label"
                        optionValue="value"
                        appendTo="body"
                        [disabled]="!isCreationMode"
                    ></p-select>
                    <label for="verify_ssl">Verify SSL?</label>
                </p-floatlabel>
            </div>
        </div>
    </app-ibase-cru-modal-content>
</form>
